/* Paranoise free-shipping progress (Oct 2026).
 * Rules (thresholds in shop currency, CAD cents): CA >= 25000 ("across most of Canada"), US >= 30000 ("to the US").
 * Liquid server-renders exact text when the cart is in CAD (marked data-pn-server="1"; left untouched here).
 * For other presentment currencies, Liquid renders a placeholder with data attributes and this script fills it:
 *   data-pn-free-cad  threshold in CAD cents
 *   data-pn-total     cart total (or cart total + this variant on PDP) in presentment cents
 *   data-pn-region    US | CA
 *   data-pn-mode      "pdp" for product-page notes (text only), otherwise cart bar (fill + label)
 *   data-pn-policy-url (pdp only) shipping policy link
 * Dawn re-renders cart sections via innerHTML, so a debounced MutationObserver re-runs the update.
 */
(function () {
  if (window.__pnFreeShipLoaded) return;
  window.__pnFreeShipLoaded = true;

  var WHERE = { US: 'to the US', CA: 'across most of Canada' };

  function rate() {
    var r = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
  }
  function fmt(cents) {
    var cur = activeCurrency();
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: cur
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }
  function strong(text) {
    var s = document.createElement('strong');
    s.textContent = text;
    return s;
  }

  function updateBar(el, threshold, total, where) {
    var remaining = Math.max(0, threshold - total);
    var fill = el.querySelector('.pn-cart-ship-bar__fill');
    var label = el.querySelector('.pn-cart-ship-bar__label');
    var pct = remaining === 0 ? 100 : Math.max(0, Math.min(100, Math.floor((total * 100) / threshold)));
    if (fill) fill.style.width = pct + '%';
    el.classList.toggle('pn-cart-ship-bar--unlocked', remaining === 0);
    if (!label) return;
    label.textContent = '';
    if (remaining === 0) {
      label.appendChild(document.createTextNode('✓ Free shipping ' + where + ' unlocked'));
    } else {
      label.appendChild(document.createTextNode('Add '));
      label.appendChild(strong(fmt(remaining)));
      label.appendChild(document.createTextNode(' more for free shipping ' + where));
    }
  }

  function updatePdp(el, threshold, total, where) {
    var remaining = Math.max(0, threshold - total);
    var policy = el.getAttribute('data-pn-policy-url') || '';
    el.textContent = '';
    if (remaining === 0) {
      var check = document.createElement('span');
      check.className = 'pn-pdp-ship-note__check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      el.appendChild(check);
      el.appendChild(document.createTextNode(' Add this and shipping ' + where + ' is free'));
    } else {
      el.appendChild(document.createTextNode("Add this and you're "));
      el.appendChild(strong(fmt(remaining)));
      el.appendChild(document.createTextNode(' away from '));
      if (policy) {
        var a = document.createElement('a');
        a.className = 'pn-pdp-ship-note__link';
        a.href = policy;
        a.textContent = 'free shipping';
        el.appendChild(a);
      } else {
        el.appendChild(document.createTextNode('free shipping'));
      }
      el.appendChild(document.createTextNode(' ' + where));
    }
  }

  function run() {
    var nodes = document.querySelectorAll('[data-pn-free-cad]');
    var r = rate();
    var cur = activeCurrency();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-pn-server') === '1') continue; // CAD: Liquid already rendered exact text
      var cad = Number(el.getAttribute('data-pn-free-cad'));
      var total = Number(el.getAttribute('data-pn-total'));
      var region = el.getAttribute('data-pn-region');
      var where = WHERE[region];
      if (!(cad > 0) || isNaN(total) || !where) continue;
      var threshold = Math.round(cad * r);
      var key = [cad, total, region, r, cur].join('|');
      if (el.getAttribute('data-pn-done') === key) continue; // avoid observer loops
      if (el.getAttribute('data-pn-mode') === 'pdp') updatePdp(el, threshold, total, where);
      else updateBar(el, threshold, total, where);
      el.setAttribute('data-pn-done', key);
    }
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      run();
    }, 50);
  }

  function start() {
    run();
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
